export default "__VITE_PUBLIC_ASSET__8e81acf7__"